export default __webpack_public_path__ + "static/media/mail_icon.f00db36b.svg";